import * as googleIcons from './icons_google';
import {
  HappyInbox as SVGHappyInbox,
  LaptopRobot as SVGLaptopRobot,
} from './icons_svg_legacy';
import { useSelector } from 'react-redux';
import { getFeatureFlag, Feature } from '../../models/features/features';
import Icon from './icon';

/**
 * @fileoverview
 * @deprecated These icon components are deprecated and should not be used in new code.
 * Please use the Icon components from @socialchorus/shared-ui-components instead.
 *
 * Legacy Note: When possible, use the Icon component directly
 * This class serves to enable feature-flagged legacy-logic to deliver old icons
 * New components should use the default Icon behaviour (Material Symbols)
 *
 */

export const Globe = (props) => {
  return googleIcons.Globe(props);
};

export const Inbox = (props) => {
  return googleIcons.Inbox(props);
};

export const Chat = (props) => {
  return googleIcons.Chat(props);
};

export const Notifications = (props) => {
  return googleIcons.Notifications(props);
};

export const Compass = (props) => {
  return googleIcons.Compass(props);
};

export const LightBulb = (props) => {
  return googleIcons.LightBulb(props);
};

const STARBURST_PATH =
  'M12.4575 0.0792389C12.9307 0.246668 13.0692 0.408324 13.5655 1.40135C14.8524 3.94166 15.7527 5.24645 17.2531 6.74754C18.7536 8.24863 20.0578 9.14928 22.597 10.4368C23.3126 10.7947 23.5665 10.9564 23.6935 11.118C23.9993 11.5222 24.0801 12.0013 23.9186 12.4574C23.7512 12.9366 23.5954 13.0637 22.5393 13.5948C20.1905 14.7841 18.7651 15.7541 17.3743 17.105C15.9028 18.5426 14.8467 20.061 13.5944 22.5436C13.0635 23.6001 12.9365 23.756 12.4575 23.9235C11.967 24.0967 11.3841 23.9696 11.0263 23.6059C10.8994 23.4789 10.6281 23.0228 10.3454 22.4455C9.16232 20.0841 8.24474 18.7505 6.77893 17.2783C5.31312 15.806 3.87039 14.8015 1.52739 13.6352C1.05418 13.3985 0.580963 13.1387 0.482857 13.0637C0.067351 12.7577 -0.123089 11.9956 0.0846639 11.4991C0.275104 11.0487 0.419377 10.9333 1.48123 10.3906C3.84153 9.18969 5.1977 8.2775 6.53655 6.98425C8.01391 5.55821 9.13346 3.97052 10.305 1.62652C10.6224 1.00299 10.8994 0.523793 11.0263 0.391005C11.3841 0.0330526 11.9612 -0.0997371 12.4575 0.0792389Z';

const StarBurst = ({ filled = true, ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox={filled ? '0 0 24 24' : '-2 -2 28 28'}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Assistant"
    {...props}
  >
    {filled ? (
      <path d={STARBURST_PATH} fill="currentColor" />
    ) : (
      <path
        d={STARBURST_PATH}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
      />
    )}
  </svg>
);

export const AssistantIcon = (props) => {
  const chatbotEnabled = useSelector((state) =>
    getFeatureFlag(state, Feature.CHATBOT_ENABLED)
  );
  const assistantCompassMode = useSelector((state) =>
    getFeatureFlag(state, Feature.ASSISTANT_ICON_IS_COMPASS)
  );

  if (chatbotEnabled) {
    return <StarBurst {...props} />;
  }

  return assistantCompassMode ? (
    <Compass style={{ fontSize: '32px' }} {...props} />
  ) : (
    <LightBulb className="filled" {...props} />
  );
};

export const DiscoverIcon = (props) => {
  const assistantCompassMode = useSelector((state) =>
    getFeatureFlag(state, Feature.ASSISTANT_ICON_IS_COMPASS)
  );
  //opposite of assistant
  return !assistantCompassMode ? (
    <Compass {...props} />
  ) : (
    <LightBulb className="filled" {...props} />
  );
};

export const HappyInbox = (props) => {
  return <SVGHappyInbox {...props} />;
};

export const Shield = (props) => {
  return googleIcons.Shield(props);
};

export const LaptopRobot = (props) => {
  return <SVGLaptopRobot {...props} />;
};

export const Profile = (props) => {
  return googleIcons.Profile(props);
};

export const SideBarProfileIcon = (props) => {
  return googleIcons.SideBarProfileIcon(props);
};

export const ChevronRight = (props) => {
  return googleIcons.ChevronRight(props);
};

export const ChevronLeft = (props) => {
  return googleIcons.ChevronLeft(props);
};

export const VideoIcon = (props) => {
  return googleIcons.VideoIcon(props);
};

export const VideoPostIcon = (props) => {
  return googleIcons.VideoPostIcon(props);
};

export const ImageIcon = (props) => {
  return googleIcons.ImageIcon(props);
};

export const NoteIcon = (props) => {
  return googleIcons.NoteIcon(props);
};

export const ArticleIcon = (props) => {
  return googleIcons.ArticleIcon(props);
};

export const LinkIcon = (props) => {
  return googleIcons.LinkIcon(props);
};

export const FeaturedIcon = (props) => {
  return googleIcons.FeaturedIcon(props);
};

export const StarFeaturedIcon = (props) => {
  return googleIcons.StarFeaturedIcon(props);
};

export const TrendingIcon = (props) => {
  return googleIcons.TrendingIcon(props);
};

export const SwitchIcon = (props) => {
  return googleIcons.SwitchIcon(props);
};

export const BookmarkIcon = (props) => {
  return googleIcons.BookmarkIcon(props);
};

export const BookmarkedIcon = (props) => {
  return googleIcons.BookmarkedIcon(props);
};

export const PostIcon = (props) => {
  return googleIcons.PostIcon(props);
};

export const ChannelsIcon = (props) => {
  return googleIcons.ChannelsIcon(props);
};

export const EditProfileIcon = (props) => {
  return googleIcons.EditProfileIcon(props);
};

export const ResetPasswordIcon = (props) => {
  return googleIcons.ResetPasswordIcon(props);
};

export const ShareIcon = (props) => {
  return googleIcons.ShareIcon(props);
};

export const SubmitCommentIcon = (props) => {
  return googleIcons.SubmitCommentIcon(props);
};

export const PersonIcon = (props) => {
  return googleIcons.PersonIcon(props);
};

export const LatestIcon = (props) => {
  return googleIcons.LatestIcon(props);
};

export const ResourcesIcon = (props) => {
  return googleIcons.ResourcesIcon(props);
};

export const InviteIcon = (props) => {
  return googleIcons.InviteIcon(props);
};

export const HomeIcon = (props) => {
  return googleIcons.HomeIcon(props);
};

export const JoinedChannelsIcon = (props) => {
  return googleIcons.JoinedChannelsIcon(props);
};

export const JoinChannelsIcon = (props) => {
  return googleIcons.JoinChannelsIcon(props);
};

export const LikeIcon = (props) => {
  return <Icon type="thumb_up" className="no-animation filled" {...props} />;
};

export const LikeIconOutline = (props) => {
  return <Icon type="thumb_up" className="no-animation" {...props} />;
};

export const SettingsIcon = (props) => {
  return googleIcons.SettingsIcon(props);
};

export const NewContentIcon = (props) => {
  return googleIcons.NewContentIcon(props);
};

export const VideoPlayIcon = (props) => {
  return googleIcons.VideoPlayIcon(props);
};

export const GroupIcon = (props) => {
  return googleIcons.GroupIcon(props);
};
